//import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { UserProfile } from 'src/app/core/models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { GDPRService } from 'src/app/core/services/rulebook';
import { Logger, MasterHelper } from 'src/app/core/utilities';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { RegulationModel } from 'src/app/core/models/regulation';
import { RegulationService } from 'src/app/core/services/regulation';
import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { ItemInfoDto } from 'src/app/core/models/rulebook/item.info-dto';
import { CommonService } from 'src/app/core/services/common/common.service';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { RegulationDetail } from 'src/app/core/models/regulation/regulation-detail';
import {
  RegulationDataModel,
  RegulationResultModel,
} from './../../../core/models/regulation/regulation.model';
import { SiblingRulebookModel } from 'src/app/core/models/rulebook/sibling-rulebook-model';
import { UserManagementService } from './../../../core/services/user-management/user-management.service';
import { JurisdictionDialogComponent } from '../../distributed-ui-components/jurisdiction-dialog/jurisdiction-dialog.component';
import { ChangeViewerDialogComponent } from '../../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import {
  ImpactOfRegulationModel,
  ImpactOfRegulationTreeModel,
} from 'src/app/core/models/regulation/impact-of-regulation.model';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { MatDialog } from '@angular/material/dialog';
import { updateRulebookModel } from 'src/app/core/models/rulebook/updateRulebookDescription';
import { translateOthersToEnglishOutputModel } from 'src/app/core/models/translate/translateOutputModel';
import { translateOthersToEnglishInputModel } from 'src/app/core/models/translate/translateInputModel';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-change-viewer-analytic',
  templateUrl: './change-viewer-analytic.component.html',
  styleUrls: ['./change-viewer-analytic.component.scss'],
})
export class ChangeViewerAnalyticComponent implements OnInit {
  @Input()
  regulationData!: RegulationDataModel;
  currentRegulationDetails: RegulationModel;
  isLoading = false;
  isRegLoading = false;
  regulation: RegulationModel;
  isLoadingRegDetails = false;
  url = 'assets/d3/index.html?id=';
  iframeSRC: any = null;
  ruleTopicsForToolTip = '';
  showChartCont = true;
  isRegChartExpanded = false;
  toastViewModel: ToastViewModel;
  isShowToast = false;
  currentRegId: number;
  isRegMovedToIA = false;
  selectedRegulationId: number;
  userProfile: UserProfile;
  isExpendedIconShow = false;
  detailType: number;
  regulationInfo: RegulationDetail;
  siblingIds: SiblingRulebookModel;
  currentRegulationId = 0;
  regulationLibraryId = 0;
  similarIds: Array<number> = [];
  showMoreSimilarity: Array<number> = [];
  isShowComparison = false;
  compareRegulationId = 0;
  secondRegulation!: RegulationModel;
  iframeSRC2: any = null;
  userJurisdiction: Array<ItemIdModel> = [];
  linkedRulesTree: Array<ImpactOfRegulationTreeModel> = [];
  templateNo: number = 1;
  treeControl = new NestedTreeControl<ImpactOfRegulationTreeModel>(
    (node) => node.children
  );
  dataSource = new MatTreeNestedDataSource<ImpactOfRegulationTreeModel>();
  treeControlComp = new NestedTreeControl<ImpactOfRegulationTreeModel>(
    (node) => node.children
  );
  dataSourceComp = new MatTreeNestedDataSource<ImpactOfRegulationTreeModel>();
  isShowDescriptionEditor: boolean = false;
  descriptionInEditor: string = '';
  isTranslateToaster: boolean = false;
  isChangeDetails: boolean = true;
  isRigMap: boolean = false;
  libraryMenu: Array<MenuItemModel> = [];

  //Regulatory Insights Generator
  isRig = false;
  isActionShow: boolean= false;

  constructor(
    private regulationService: RegulationService,
    private sanitizer: DomSanitizer,
    private gdprService: GDPRService,
    public commonService: CommonService,
    private sessionService: SessionService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private eleRef: ElementRef,
    private userService: UserManagementService
  ) {
    this.regulation = new RegulationModel();
    this.currentRegulationDetails = new RegulationModel();
    this.regulationInfo = new RegulationDetail();
    this.toastViewModel = new ToastViewModel();
    this.currentRegId = 0;
    this.selectedRegulationId = 0;
    this.detailType = 0;
    this.userProfile = new UserProfile();
    this.siblingIds = new SiblingRulebookModel();

    this.isExpendedIconShow =
      this.router.url.indexOf('/change-detail') >= 0
        ? true
        : this.router.url.indexOf('/library/rule-detail') >= 0
          ? true
          : false;
    if (this.isExpendedIconShow) {
      this.detailType = Number(
        this.route.snapshot.queryParamMap.get('detailType')
      );
    }
    this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.iframeSRC
    );
    this.iframeSRC2 = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.iframeSRC2
    );

    this.dataSource.data = this.linkedRulesTree;
  }
  hasChild = (_: number, node: ImpactOfRegulationTreeModel) =>
    !!node.children && node.children.length > 0;
  ngOnInit(): void {
    this.getUserMenu();
    this.currentRegulationId = this.regulationData.id;
    if (this.router.url.indexOf('/change-detail') >= 0) {
      this.regulationData.libraryId = Number(
        this.route.snapshot.queryParamMap.get('libId')
      );
    }
    this.regulationLibraryId = this.regulationData.libraryId;
    if (this.regulationData.similarIndex) {
      const similarityIndex = this.regulationData.similarIndex.split('||');
      similarityIndex.forEach((element) => {
        this.similarIds.push(+element.split('|')[0]);
      });
    }
    this.fetchUserProfile();
    this.fetchUserJurisdiction();
    //this.getRegulation();
  }



  tabChanged(event: any): void {
    const tabViewElement = document.getElementById('tabView');
    if (tabViewElement) {
      tabViewElement.scrollIntoView();
    }
    //document.getElementById('tabView').scrollIntoView();
  }

  fetchUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      if (user.userId > 0) {
        this.userProfile = user;
        this.getRegulation();
      }
    });
  }

  getImpactRegulation(): void {
    this.regulationService
      .GetImpactOfRegulation(this.currentRegulationId)
      .subscribe((data: ImpactOfRegulationModel[]) => {
        this.linkedRulesTree = this.convertToImpactOfRegulationTreeModel(
          data,
          '1'
        );

        this.dataSource.data = this.linkedRulesTree;
        this.treeControl.dataNodes = this.linkedRulesTree;

        this.treeControl.dataNodes.forEach((levle1, level1Index) => {
          this.treeControl.expand(this.treeControl.dataNodes[level1Index]);

        });
      });
  }

  getImpactRegulationComp(): void {
    this.regulationService
      .GetImpactOfRegulation(this.compareRegulationId)
      .subscribe((data: ImpactOfRegulationModel[]) => {
        this.linkedRulesTree = this.convertToImpactOfRegulationTreeModel(
          data,
          '1'
        );

        this.dataSourceComp.data = this.linkedRulesTree;
        this.treeControlComp.dataNodes = this.linkedRulesTree;

        this.treeControlComp.dataNodes.forEach((levle1, level1Index) => {
          this.treeControlComp.expand(
            this.treeControlComp.dataNodes[level1Index]
          );
        });
      });
  }

  convertToImpactOfRegulationTreeModel(
    impactOfRegulations: ImpactOfRegulationModel[],
    parentId?: string
  ): Array<ImpactOfRegulationTreeModel> {
    let data: Array<ImpactOfRegulationTreeModel> = [];

    data = impactOfRegulations
      .filter((f) => f.parent == parentId)
      .map((e) => {
        return {
          name: e.name,
          hyperlink: e.hyperlink,
          parent: e.parent,
          realname: e.realname,
        } as ImpactOfRegulationTreeModel;
      });
    data.forEach((d) => {
      d.children = this.convertToImpactOfRegulationTreeModel(
        impactOfRegulations,
        d.name.toString()
      );
    });
    return data;
  }

  getRegulation(): void {
    this.isRegLoading = true;
    this.regulationService
      .getRegulation(this.regulationLibraryId, this.currentRegulationId)
      .subscribe(
        (data: RegulationModel) => {
          this.isRegLoading = false;
          if (data) {
            if (this.regulationData.filterType && data.similarityIndex) {
              const similarityIndex = data.similarityIndex.split('||');
              similarityIndex.forEach((element) => {
                this.similarIds.push(+element.split('|')[0]);
              });
            }
            this.regulation = data;
            let isPresent = this.regulationData.regulations.find(a => a.id == this.regulation.id);
            if (isPresent !== undefined) {
              this.currentRegulationDetails =
                this.regulationData.regulations.filter((element) => {
                  return element.id === this.regulationData.id;
                })[0];
                this.processAssessData();
              //this.currentRegulationDetails.isClosed=true;
            }
            else {
              this.processAssessData();
            }
            this.isActionShow=true;
            this.getImpactRegulation();
            this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.url + this.currentRegulationId
            );

            this.ruleTopicsForToolTip = this.regulation.ruleTopic
              ? this.regulation.ruleTopic.toString().split(',').join('<br/>')
              : '';
            this.regulation.date = MasterHelper.formatDate(
              this.regulation.date,
              'DD-MMM-YYYY'
            ).toString();

            if (
              this.regulation.previousVersions &&
              this.regulation.previousVersions.length
            ) {
              this.regulation.previousVersions.forEach((a) => {
                a.date = MasterHelper.formatDate(
                  a.date,
                  'DD-MMM-YYYY'
                ).toString();
              });
            }
          }
        },
        (error: HttpErrorResponse) => {
          Logger.log(this.constructor.name, error.error);
        }
      );
  }

  expandPanel(): void {
    this.showChartCont = false;
    this.isRegChartExpanded = !this.isRegChartExpanded;
    setTimeout(() => {
      this.showChartCont = true;
    }, 100);
  }

  openPopUp(id: number): void {
    this.userService
      .getUserJurisdictions()
      .subscribe((result: ItemIdModel[]) => {
        if (result && result.length === 1) {
          const selectedJuridiction =
            MasterHelper.getStringArrayFromObjectArray(result);
          this.addImpactAssessment(selectedJuridiction, id);
        } else {
          this.selectedRegulationId = id;
          const dialogRef = this.dialog.open(JurisdictionDialogComponent, {
            width: '1000px',
            data: {
              result: result,
              regulationDetails: this.regulation,
              type: 'assess',
            },
          });
          dialogRef.afterClosed().subscribe((response) => {
            if (response) {
              this.addImpactAssessment(
                response.result,
                this.selectedRegulationId
              );
            } else {
              this.selectedRegulationId = 0;
            }
          });
        }
      });
  }

  async addImpactAssessment(jurisdictions: Array<string>, id: number) {
    let data: any = await this.gdprService.getTemplateNo().toPromise();
    this.templateNo = data.result;
    this.isRegMovedToIA = true;
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.id = id;
    itemInfoDto.screenUrl = this.router.url;
    itemInfoDto.jurisdictions = jurisdictions;
    if (this.templateNo == 4) {
      this.gdprService
        .moveToImpactAssessment4(itemInfoDto)
        .subscribe((data: any) => {
          this.alertMessage(data);
        });
    }
    else if (this.templateNo == 5) {
      this.gdprService
        .moveToImpactAssessment5(itemInfoDto)
        .subscribe((data: any) => {
          this.alertMessage(data);
        });
    }
    else {
      this.gdprService
        .moveToImpactAssessment(itemInfoDto)
        .subscribe((data: any) => {
          this.alertMessage(data);
        });
    }

  }

  alertMessage(data: any): void {
    if (data.result?.resultId > 0 && data.result.status) {
      this.toastViewModel.Title = 'Success';
      this.toastViewModel.Type = 'success';
      this.toastViewModel.Message = 'Regulation Moved to Impact Assessment';
    } else if (!data.result?.status && data.result?.message) {
      this.toastViewModel.Title = 'Warning';
      this.toastViewModel.Type = 'warning';
      this.toastViewModel.Message = data.result?.message;
    } else {
      this.toastViewModel.Title = 'Warning';
      this.toastViewModel.Type = 'warning';
      this.toastViewModel.Message =
        'Impact Assessment on this Change Id already exists';
    }
    this.isShowToast = true;
    setTimeout(() => {
      this.isRegMovedToIA = false;
      this.isShowToast = false;
      window.location.href =
        '/impact-assessment/details/impact/' + this.templateNo + '/' + data.result.resultId;
      MasterHelper.saveOnBrowser('_iaid', data.result.resultId);
    }, 1500);
  }

  openDialog(): void {
    if (this.regulation.regulationDetails) {
      this.regulationInfo = this.regulation.regulationDetails;
    } else {
      this.regulationInfo.regulationId = this.regulation.id;
    }
    this.regulationInfo.filterType = '';
    this.regulationInfo.title = this.regulation.title;
    this.regulationInfo.type = this.regulation.pubType;
    this.regulationInfo.similarIndex = this.regulation.similarityIndex;
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationInfo,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateRegulationDetail(result, this.regulation.id);
      } else {
        this.regulationInfo = new RegulationDetail();
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
    regulation.regulationId = id;
    regulation.userId = this.userProfile.externalUserId;
    regulation.isRead = true;
    regulation.status = +regulation.status;
    this.regulationService.updateRegulationInfo(regulation).subscribe(() => {
      this.successAlert('Successfully updated');
      this.getSiblings('Next');
    });
    //}
  }

  successAlert(text: string): void {
    this.toastViewModel.Title = 'Success';
    this.toastViewModel.Type = 'success';
    this.toastViewModel.Message = text;
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 3000);
  }

  warningAlert(text: string): void {
    this.toastViewModel.Title = 'Warning';
    this.toastViewModel.Type = 'warning';
    this.toastViewModel.Message = text;
    this.isShowToast = true;
    setTimeout(() => {
      this.isShowToast = false;
    }, 3000);
  }

  checkSibling(id: number, type: string): boolean {
    const index = this.regulationData.regulations.findIndex((a) => a.id === id);
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.regulationData.regulations[index + 1] ? true : false;
      } else {
        return this.regulationData.regulations[index - 1] ? true : false;
      }
    }
  }

  getSiblings(type: string): void {
    const index = this.regulationData.regulations.findIndex(
      (a) => a.id === this.currentRegulationId
    );
    if (type === 'Next') {
      this.currentRegulationId = this.regulationData.regulations[index + 1].id;
    } else {
      this.currentRegulationId = this.regulationData.regulations[index - 1].id;
    }
    this.getRegulation();
  }

  checkSimilarSibling(id: number, type: string): boolean {
    const index = this.similarIds.indexOf(+id);
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.similarIds[index + 1] ? true : false;
      } else {
        return this.similarIds[index - 1] ? true : false;
      }
    }
  }

  getSimilarSiblings(type: string): void {
    const index = this.similarIds.indexOf(+this.currentRegulationId);
    if (type === 'Next') {
      this.currentRegulationId = this.similarIds[index + 1];
    } else {
      this.currentRegulationId = this.similarIds[index - 1];
    }
    this.getRegulation();
  }

  sortArray(itemArray: string[]): string[] {
    return MasterHelper.sortArray(itemArray, 'asc');
  }

  getElementsByFilter(itemArray: string[], filter: string): string[] {
    if (filter === 'All') {
      return itemArray && itemArray.length > 5
        ? itemArray.slice(5, itemArray.length - 1)
        : itemArray;
    } else {
      return itemArray && itemArray.length > 5
        ? itemArray.slice(0, 5)
        : itemArray;
    }
  }

  showHideSimilarity(id: number): void {
    const index = this.showMoreSimilarity.indexOf(id);
    if (index >= 0) {
      this.showMoreSimilarity.splice(index, 1);
    } else {
      this.showMoreSimilarity.push(id);
    }
  }

  showMoreLessResult(id: number): boolean {
    const index = this.showMoreSimilarity.indexOf(id);
    return index >= 0 ? true : false;
  }

  showComparison(id: number): void {
    this.compareRegulationId = id;
    this.isShowComparison = true;
    this.getSecondRegulation();
  }

  getSecondRegulation(): void {
    this.isRegLoading = true;
    this.regulationService
      .getRegulation(this.regulationLibraryId, this.compareRegulationId)
      .subscribe(
        (data: RegulationModel) => {
          this.isRegLoading = false;
          if (data) {
            this.secondRegulation = data;
            this.getImpactRegulationComp();
            this.iframeSRC2 = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.url + this.compareRegulationId
            );
            this.secondRegulation.date = MasterHelper.formatDate(
              this.secondRegulation.date,
              'DD-MMM-YYYY'
            ).toString();

            if (
              this.secondRegulation.previousVersions &&
              this.secondRegulation.previousVersions.length
            ) {
              this.secondRegulation.previousVersions.forEach((a) => {
                a.date = MasterHelper.formatDate(
                  a.date,
                  'DD-MMM-YYYY'
                ).toString();
              });
            }
          }
        },
        (error: HttpErrorResponse) => {
          Logger.log(this.constructor.name, error.error);
        }
      );
  }

  isCurrentAction(event: any): void {
    if (event) {
      this.eleRef.nativeElement.style.setProperty(
        '--side-border',
        '1px solid rgba(0, 0, 0, 0.16)'
      );
    }
  }

  checkEditPermission(
    closedRegUsers: string[],
    jurisdiction: string
  ): boolean | undefined {
    if (closedRegUsers && closedRegUsers.length === 0) {
      return false;
    } else {
      return this.checkJurisdictionPermission(jurisdiction);
    }
  }

  fetchUserJurisdiction(): void {
    this.userService
      .getUserJurisdictions()
      .subscribe((result: ItemIdModel[]) => {
        this.userJurisdiction = result;
      });
  }

  checkJurisdictionPermission(jurisdiction: string): boolean | undefined {
    if (jurisdiction) {
      const jurisArr = jurisdiction.split(',');
      const commonItems = new Array<string>();
      jurisArr.forEach((item) => {
        this.userJurisdiction.forEach((element2) => {
          if (item.toUpperCase() === element2.name.toUpperCase()) {
            commonItems.push(item);
          }
        });
      });
      return commonItems.length > 0 ? true : false;
    }
  }
  getContrastYIQ(hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result == null) return null;
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 150 ? 'black' : 'white';
  }

  processAssessData() {
    //let selectedDivision = localStorage.getItem("selectedDivisionName");
    let selectedDivision = this.userProfile.lastUsedJurisdictionName;
    if (this.currentRegulationDetails.currentActions != null) {
      let assessedData = this.currentRegulationDetails.currentActions.filter(element => {
        return element.closedType === 'Assess' && element.jurisdiction === selectedDivision;
      });
      let closedData = this.currentRegulationDetails.currentActions.filter(element => {
        return element.closedType === 'Closed' && element.jurisdiction === selectedDivision;
      });
      if (assessedData.length > 0) {
        this.currentRegulationDetails.isAssessed = true;
      } else {
        this.currentRegulationDetails.isAssessed = false;
      }
      if (closedData.length > 0) {
        this.currentRegulationDetails.isClosed = true;
      } else {
        this.currentRegulationDetails.isClosed = false;
      }
    }
    else {
      this.currentRegulationDetails.isAssessed = false;
      this.currentRegulationDetails.isClosed = false;
    }
  }

  //translator
  editButtonClick() {
    let splitDesc = this.regulation.description.split('\n');
    let newArray: string[] = []; // Fix: Initialize newArray as an empty array of type string[]
    if (splitDesc.length > 0) {
      splitDesc.forEach(element => {
        element = '<p>' + element + '</p>';
        newArray.push(element);
      });
      this.descriptionInEditor = newArray.join(' ');
    }
    else {
      this.descriptionInEditor = this.regulation.description;
    }

    this.isShowDescriptionEditor = !this.isShowDescriptionEditor;
  }
  saveDescriptionButtonClick() {
    let descriptionModel = new updateRulebookModel();
    descriptionModel.id = this.regulation.id;
    descriptionModel.rulebookDescription = this.descriptionInEditor;
    this.regulationService.updateRegulationDescription(descriptionModel).subscribe(
      (data: any) => {
        if (data.message == "Successfull") {
          this.regulation.description = this.descriptionInEditor;
          this.isShowDescriptionEditor = !this.isShowDescriptionEditor;
        }
      })
  }
  cancelDescriptionButtonClick() {
    this.descriptionInEditor = this.regulation.description;
    this.isShowDescriptionEditor = !this.isShowDescriptionEditor;
  }
  joseToken: any = [];
  streamlitUrl!: string;
  isAssessmentLoader: boolean = false;
  translateDescription() {
    this.isAssessmentLoader = true;
    const containsSubstring = this.regulation.description.includes("Non-Legal Translation of the Regulatory Text");
    if (!containsSubstring) {
      let ob = new translateOthersToEnglishInputModel();
      ob.textToTranslate = this.regulation.description;
      ob.tableName = "updatesDB";
      ob.updatesId = this.regulation.id;
      this.regulationService.sendTranslatePostRequest(this.joseToken.message, ob).subscribe((response: any) => {

        if (response && response?.message) {
          if (response?.message == "Text already in english") {
            this.toastViewModel.Title = 'Warning';
            this.toastViewModel.Type = 'warning';
            this.toastViewModel.Message = 'Text already in english';
          }
          else {
            this.regulation.description = response.message;
            this.toastViewModel.Title = 'Success';
            this.toastViewModel.Type = 'success';
            this.toastViewModel.Message = 'Language translation successful';
          }

          this.isTranslateToaster = true;
          setTimeout(() => {
            this.isTranslateToaster = false;
          }, 3500);
        }
        else {
          this.toastViewModel.Title = 'Warning';
          this.toastViewModel.Type = 'warning';
          this.toastViewModel.Message = 'Language translation failed due to character length limit';
          this.isTranslateToaster = true;
          setTimeout(() => {
            this.isTranslateToaster = false;
          }, 3500);
        }
        this.isAssessmentLoader = false;
      })

    }
    else {
      this.toastViewModel.Title = 'Warning';
      this.toastViewModel.Type = 'warning';
      this.toastViewModel.Message = 'The Description is already translated';
      this.isTranslateToaster = true;
      setTimeout(() => {
        this.isTranslateToaster = false;
      }, 3500);
      this.isAssessmentLoader = false;
    }
  }

  tabMenuChanged(event: MatTabChangeEvent): void {
    const selectedLabel = event.tab.textLabel;

    if (selectedLabel === 'Change Details') {
      this.isChangeDetails = true;
      this.isRigMap = false;
      this.isRig = false;
    } else if (selectedLabel === 'RIG') {
      this.isChangeDetails = false;
      this.isRigMap = false;
      this.isRig = true;
    } else if (selectedLabel === 'MAPS') {
      this.isChangeDetails = false;
      this.isRigMap = true;
      this.isRig = false;
    }
  }

  //For Role Based Operation in Maps and Rig
  getUserMenu(): void {
    this.analyticsService.getLibraryMenu().subscribe((data: MenuItemModel[]) => {
      this.libraryMenu = data;
    });
  }

  checkRoutePermissionWithName(screenName: string): boolean {
    return this.libraryMenu.find(a => a.screenName === screenName && a.parentId != null) ? true : false;
  }
  checkRoutePermissionWithUrl(currentUrl: string): boolean {
    return this.libraryMenu.find(a => a.screenUrl === currentUrl && a.parentId != null) ? true : false;
  }
}
